export default [
  {
    title: 'Admin Area',
    level: 3,
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Settings',
        route: 'settings',
        level: 3,
        icon: 'SettingsIcon',
      },
      {
        title: 'Pages',
        route: 'page',
        level: 3,
        icon: 'BookOpenIcon',
      },
      // {
      //   title: 'PDF Reports',
      //   route: 'pdfreports',
      //   level: 3,
      //   icon: 'BookOpenIcon',
      // },
      {
        title: 'Holidays',
        route: 'holiday',
        level: 3,
        icon: 'CpuIcon',
      },
      {
        title: 'HotAlert Conditions',
        route: 'hotalertcondition',
        level: 3,
        icon: 'BellIcon',
      },
      {
        title: 'Appeals',
        route: 'appeals',
        level: 3,
        icon: 'MessageSquareIcon',
      },
      {
        title: 'Projects',
        route: 'project',
        level: 3,
        icon: 'BoxIcon',
      },
      {
        title: 'Progress',
        route: 'calculationprogress',
        level: 3,
        icon: 'CpuIcon',
      },
      {
        title: 'Report',
        route: 'report',
        level: 3,
        icon: 'CpuIcon',
      },
      {
        title: 'Scheduled Delivery',
        route: 'scheduledbox',
        level: 3,
        icon: 'ClockIcon',
      },
      {
        title: 'User Groups',
        route: 'usergroup',
        level: 3,
        icon: 'TagIcon',
      },
      {
        title: 'Users',
        route: 'user',
        level: 3,
        icon: 'UsersIcon',
      },
    ],
  },
]
